import * as React from 'react';
import { useEffect, useRef } from 'react';
import { DH } from '../../data-hooks';
import { makeLinksClickable } from './utils';
export var ChatMessage = function (_a) {
    var children = _a.children;
    var textRef = useRef();
    // Adding links in useEffect is safer because this keeps other
    // tags escaped using default React escape logic
    useEffect(function () {
        if (textRef.current) {
            textRef.current.innerHTML = makeLinksClickable(textRef.current.innerHTML);
        }
    }, [children, textRef]);
    return (React.createElement("span", { "data-hook": DH.CHAT_MESSAGE_TEXT, ref: textRef }, children));
};
//# sourceMappingURL=chat-message.js.map